/* eslint-disable no-nested-ternary */
import React, { ReactElement, useEffect, useState } from 'react';
import { HeadTag } from 'shared/components';
import { Box, CircularProgress, Stack, Typography } from '@mui/material';
import { Formik } from 'formik';
import PageHeader from 'shared/components/PageHeader';
import {
  AppPrimaryButton,
  AppPrimaryButtonOutlined,
} from 'shared/components/AppComponents';
import AIRiskBaselineDashboard from './components/AIRiskBaselineDashboard';
import { useNavigate } from 'react-router-dom';
import { AIRiskBaselineService } from 'services/AIRiskBaselineService';
import ElectricBoltIcon from '@mui/icons-material/ElectricBolt';
import LayersIcon from '@mui/icons-material/Layers';
import FileDownloadIcon from '@mui/icons-material/FileDownload';
import { useSelector } from 'react-redux';
import { IAppState } from 'state/RootReducer';

const AIRiskBaseline = (): ReactElement => {
  const [questionnaireData, setQuestionnaireData] = useState<any>(null);
  const [overviewData, setOverviewData] = useState<any>(null);
  const [inProgressAssessment, setInProgressAssessment] = useState<any>(null);
  const [completedAssessment, setCompletedAssessment] = useState<any>(null);
  const [isLoading, setIsLoading] = useState<any>(true);
  const navigate = useNavigate();
  const [completedPage, setCompletedPage] = useState(1);
  const [inProgressPage, setInProgressPage] = useState(1);
  const [completedTotal, setCompletedTotal] = useState(0);
  const [inProgressTotal, setInProgressTotal] = useState(0);
  const PAGE_SIZE = 10;
  const completedTotalPages = Math.ceil(completedTotal / PAGE_SIZE);
  const inProgressTotalPages = Math.ceil(inProgressTotal / PAGE_SIZE);
  const { orgACLConfig } = useSelector(
    (state: IAppState) => state.baseAppState
  );

  const handleGetQuestionnaries = (): void => {
    AIRiskBaselineService.getAIRiskQuestionnaries()
      .then((res) => {
        setQuestionnaireData(res.data.data?.questionnaires);
      })
      .catch(() => {});
  };

  const handleGetOverview = (): void => {
    AIRiskBaselineService.getAIRiskBaselineOverview()
      .then((res) => {
        setOverviewData(res.data.data);
      })
      .catch(() => {
        // Utils.handleErrorResponse(error);
      })
      .finally(() => {
        setIsLoading(false);
      });
  };

  const handleGetCompleted = (page: number): void => {
    AIRiskBaselineService.getAIRiskAssessments('completed', page)
      .then((res) => {
        setCompletedAssessment(res.data.data);
        setCompletedTotal(res.data.data?.pagination?.total);
      })
      .catch(() => {});
  };

  const handleGetInProgress = (page: number): void => {
    AIRiskBaselineService.getAIRiskAssessments('in_progress', page)
      .then((res) => {
        setInProgressAssessment(res.data.data);
        setInProgressTotal(res.data.data?.pagination?.total);
      })
      .catch(() => {});
  };

  useEffect(() => {
    handleGetQuestionnaries();
    handleGetCompleted(1);
    handleGetInProgress(1);
    handleGetOverview();
  }, []);

  useEffect(() => {
    handleGetCompleted(completedPage);
  }, [completedPage]);

  useEffect(() => {
    handleGetInProgress(inProgressPage);
  }, [inProgressPage]);

  return (
    <>
      {isLoading ? (
        <Box className="empty-content">
          <CircularProgress />
        </Box>
      ) : (
        <>
          <PageHeader
            title={
              <Box
                sx={{
                  display: 'flex',
                  gap: '0.5rem',
                  alignItems: 'center',
                }}
              >
                <Typography
                  className="f26 fw-7 word-break"
                  sx={{ maxWidth: '500px', lineHeight: '30px' }}
                >
                  AI Risk Baseline Assessment
                </Typography>{' '}
              </Box>
            }
            description="Add new assessment — you can continue where you left off."
            actions={
              <Box
                sx={{
                  display: 'flex',
                  gap: 1,
                }}
              >
                {false && (
                  <AppPrimaryButton
                    className="btn-small"
                    onClick={() => {}}
                    startIcon={<FileDownloadIcon />}
                    title="Download Report"
                  />
                )}
                {orgACLConfig.dashboard.includes(
                  'dashboard.aiRiskBaseLine.addEssential'
                ) && (
                  <AppPrimaryButtonOutlined
                    className="btn-small"
                    onClick={() =>
                      navigate('/ai-risk-baseline/new', {
                        state: {
                          questionnaireData,
                          mode: 'Essential',
                        },
                      })
                    }
                    startIcon={<ElectricBoltIcon />}
                    title="Add Essential"
                  />
                )}
                {orgACLConfig.dashboard.includes(
                  'dashboard.aiRiskBaseLine.addComprehensive'
                ) && (
                  <AppPrimaryButtonOutlined
                    className="btn-small"
                    onClick={() =>
                      navigate('/ai-risk-baseline/new', {
                        state: {
                          questionnaireData,
                          mode: 'Comprehensive',
                        },
                      })
                    }
                    title="New Comprehensive"
                    startIcon={<LayersIcon />}
                  />
                )}
              </Box>
            }
          />
          <Box className="dashboard-page partnershub">
            <HeadTag title="AI Risk Baseline" />

            <Box className="partnershub-wrapper">
              <Formik
                initialValues={{ 'search-partners-hub': '' }}
                onSubmit={() => {
                  console.log('test');
                }}
              >
                <Stack direction="column">
                  <Box className="partner-list">
                    <AIRiskBaselineDashboard
                      completedAssessment={completedAssessment}
                      inProgressAssessment={inProgressAssessment}
                      completedPage={completedPage}
                      completedTotalPages={completedTotalPages}
                      setCompletedPage={setCompletedPage}
                      inProgressPage={inProgressPage}
                      inProgressTotalPages={inProgressTotalPages}
                      setInProgressPage={setInProgressPage}
                      overviewData={overviewData}
                      handleGetInProgress={handleGetInProgress}
                    />
                  </Box>
                </Stack>
              </Formik>
            </Box>
          </Box>
        </>
      )}
    </>
  );
};

export default AIRiskBaseline;
